const genRandomHex: (size: number) => string = (size: number) =>
  [...Array(size)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join('');

export default genRandomHex;
